/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ForumSelectDetailSchools.vue?vue&type=template&id=4eb33821&scoped=true"
import script from "./ForumSelectDetailSchools.vue?vue&type=script&setup=true&lang=js"
export * from "./ForumSelectDetailSchools.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ForumSelectDetailSchools.vue?vue&type=style&index=0&id=4eb33821&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb33821",
  null
  
)

export default component.exports